/**
 * One-line loading placeholder shown in a UnitsTable cell while the per-unit
 * request is in flight. Rendered inside an existing Table.Cell.
 */
import { LoadingParagraph } from '@zg-rentals/loading-components';

type Props = {
  loadingWidth: string;
};

const SkeletonCell = ({ loadingWidth }: Props) => {
  return (
    <LoadingParagraph textStyle="body-sm" isLoading={true} loadingWidth={loadingWidth}>
      &nbsp;
    </LoadingParagraph>
  );
};

export default SkeletonCell;
